import { render, staticRenderFns } from "./Cases_part2.vue?vue&type=template&id=1ab0a8b7&scoped=true&"
import script from "./Cases_part2.vue?vue&type=script&lang=js&"
export * from "./Cases_part2.vue?vue&type=script&lang=js&"
import style0 from "./Cases_part2.vue?vue&type=style&index=0&id=1ab0a8b7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab0a8b7",
  null
  
)

export default component.exports